"use client";
import {
  accordion_default
} from "./chunk-GVLFQOT4.mjs";
import "./chunk-RCYVG55M.mjs";
import {
  useAccordionItem
} from "./chunk-A4O7O37M.mjs";
import {
  useAccordion
} from "./chunk-RITOLLZ6.mjs";
import {
  accordion_item_base_default
} from "./chunk-HAJUSXOG.mjs";
export {
  accordion_default as Accordion,
  accordion_item_base_default as AccordionItem,
  useAccordion,
  useAccordionItem
};
